import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    tfaEnableRes: [],
    tfaDisableRes: [],
    verifytfaRes: [],
    error: "",
}

const tfaSettingSlice = createSlice({
    name: 'tfaSettings',
    initialState,
    reducers: {
        enable: (state, action) => {
            state.tfaEnableRes = action.payload
        },
        disable: (state, action) => {
            state.tfaDisableRes = action.payload
        },
        verify: (state, action) => {
            state.verifytfaRes = action.payload
        }
    }
})

export const { enable, disable, verify } = tfaSettingSlice.actions;
export default tfaSettingSlice.reducer;


export const enableTfa = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.ENABLE_TFA}`, data);
            callback(response)
            dispatch(enable(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const verifyTfa = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.VERIFY_TFA}`, data);
            callback(response)
            dispatch(verify(response.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }
export const disableTfa = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.DISABLE_TFA}`, data);
            callback(response)
            dispatch(disable(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

